'use strict';
define(function () {
    var constant = {
        ukId: '10151',
        ieId: '10451',
        ukSearch: '/search',
        ieSearch: '/ie/MSFindItemsByKeyword',
        ukFlagID: 'GB',
        ieFlagID: 'IE',
        ukCountryName: 'United Kingdom (£)',
        ieCountryName: 'Ireland (€)',
        ukCountryNameI: 'United Kingdom',
        ieCountryNameI: 'Ireland'
    };
    return constant;
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/Constant.js